import styled from 'styled-components'

export const DocumentList = styled.div`
  display: flex;
  gap: 16px;
`

export const DocumentItem = styled.div`
  display: flex;
  width: 500px;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 10px;
  border: 1px solid #dcdfe4;
  border-radius: 12px;
  background: #fff;

  .left {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
  }

  .icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon i {
    margin: 0;
    color: #6b7280;
  }
`

export const FileInfo = styled.div`
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 4px;
  }
`

export const FileMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: #6b7280;
  font-size: 14px;
`

export const FileType = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef1f4;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
`